import { makeStyles } from '@rbx/ui';
import {
  assistantMaxWidth,
  assistantIsMobileBreakpoint,
} from '../constants/assistantStyleConstants';

const useAssistantStyles = makeStyles()((theme) => ({
  container: {
    margin: '0 auto',
    padding: theme.spacing(0, 4),
    overflowY: 'auto',
    // avoid changing page width if scrollbar present
    scrollbarGutter: 'stable both-edges',
    [theme.breakpoints.down(assistantIsMobileBreakpoint)]: {
      padding: theme.spacing(2),
    },
  },

  wrapper: {
    maxWidth: assistantMaxWidth,
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    margin: '0 auto',
    overflow: 'visible',
  },
}));

export default useAssistantStyles;
